
import { formatPriceWithoutCurrency } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, prop, Vue } from "vue-class-component";
import Card from "../../card/index.vue";

class Props {
  data = prop<object>({
    default: null,
    type: Object
  });
  loading = prop<boolean>({
    default: false,
    type: Boolean
  });
  isShowTotal = prop<boolean>({
    default: true,
    type: Boolean
  });
  backgroundColor = prop<string>({
    default: "",
    type: String
  });
}
@Options({ components: { Card } })
class IndexV2 extends Vue.with(Props) {
  get accountCurrency() {
    return AccountController.accountData?.accountCurrency ?? "IDR";
  }

  translateTitle(title: string) {
    if (!title) {
      return "";
    }

    return String(this.$t(title));
  }

  formatPriceWithoutCurrency(value: number) {
    return formatPriceWithoutCurrency(
      value,
      this.accountCurrency as "IDR" | "MYR"
    );
  }
}
export default IndexV2;
